/**
 * Class for ???.
 *
 * @class      Media (name)
 */
export class Media
{

	static addListeners()
	{
		// Wait for DOMContentLoaded
		$( document ).ready(
			function()
			{
				// Initiate the slideshow
				Media.initiateSlideshow();
			}
		);
	}





	/**
	 * Initiates flexslider among other things.
	 */
	static initiateSlideshow()
	{
		// Boot up flex slider
		$( '.media-slider.flexslider' ).flexslider(
			{
				easing:      'linear',
				animation:   'fade',
				controlNav:   true,
				directionNav: true,
				pausePlay:    false,
			}
		);


		// Remember to have pausePlay property turned off = false because of IE11 bug
		var pausePlay;
		pausePlay = true;

		if ( pausePlay === false )
		{
			$( '.flex-pauseplay' ).remove();
		}
		else
		{
			// This click event because flexsliders pausePlay not working in IE11
			$( '.flex-pauseplay' ).on(
				'click',
				function( e )
				{
					e.preventDefault();

					if ( $( '.flex-pauseplay a' ).hasClass( 'flex-pause' ) )
					{
						$( '.flex-pauseplay a' ).removeClass( 'flex-pause' );
						$( '.flex-pauseplay a' ).addClass( 'flex-play' );
						$( '.media-slider.flexslider' ).flexslider( 'pause' );
					}
					else if ( $( '.flex-pauseplay a' ).hasClass( 'flex-play' ) )
					{
						$( '.flex-pauseplay a' ).removeClass( 'flex-play' );
						$( '.flex-pauseplay a' ).addClass( 'flex-pause' );
						$( '.media-slider.flexslider' ).flexslider( 'play' );

					}
				}
			);
		}
	}
}



// WEBPACK FOOTER //
// ../wp-content/themes/wisesite/assets/js/modules/media/media.js